<div class="modal-content">
  <div class="modal-header bg-tertiary">
    <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">Translation Knowledge</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col">
        <button (click)="tab = 'simple'"
          [class.btn-primary]="tab !== 'simple'"
          [class.btn-outline-primary]="tab === 'simple'"
        class="btn w-100" type="button">Simple code</button>
      </div>

      <div class="col">
        <button (click)="tab = 'dynamic'"
          [class.btn-primary]="tab !== 'dynamic'"
          [class.btn-outline-primary]="tab === 'dynamic'"
        class="btn w-100" type="button">Dynamic code</button>
      </div>
    </div>

    <div class="table-responsive">
      @if (tab === 'simple') {
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Code</th>
              <th>Example result</th>
            </tr>
          </thead>
          <tbody>
            @for (shortcode of shortCodes; track shortcode) {
              <tr>
                <td>
                  <code (click)="clipboard.copy(getCode(shortcode.code))" role="button">{{ getCode(shortcode.code) }}</code>
                </td>
                <td>{{ shortcode.example }}</td>
              </tr>
            }
          </tbody>
        </table>
      }

      @if (tab === 'dynamic') {
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Dynamic Code</th>
              <th style="width: 100px">Parameter</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Countdown'))" role="button">{{ getDynamicCode('Countdown') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Countdown']" placeholder="Time in seconds or 'midnight'" type="text"/>
              </td>
              <td>{{ countdown() }}</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Countdown_Day'))" role="button">{{ getDynamicCode('Countdown_Day') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Countdown_Day']" placeholder="Days" type="number" min="1" step="1"/>
              </td>
              <td>{{ countdownDay() }}</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Countdown_From'))" role="button">{{ getDynamicCode('Countdown_From') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Countdown_From']" placeholder="Date" type="date"/>
              </td>
              <td>{{ countdownFrom() }}</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Day_Month'))" role="button">{{ getDynamicCode('Day_Month') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Day_Month']" placeholder="Offset (in days)" type="number" min="1" step="1"/>
              </td>
              <td>{{ dayMonth() }}</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Day_Month_Year'))" role="button">{{ getDynamicCode('Day_Month_Year') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Day_Month_Year']" placeholder="Offset (in days)" type="number" min="1" step="1"/>
              </td>
              <td>{{ dayMonthYear() }}</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Day_Ago'))" role="button">{{ getDynamicCode('Day_Ago') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Day_Ago']" placeholder="Days" type="number" min="1" step="1"/>
              </td>
              <td>{{ dynamicShortCodes['Day_Ago'] }} day{{ dynamicShortCodes['Day_Ago'] > 1 ? 's' : '' }} ago</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Week_Ago'))" role="button">{{ getDynamicCode('Week_Ago') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Week_Ago']" placeholder="Weeks" type="number" min="1" step="1"/>
              </td>
              <td>{{ dynamicShortCodes['Week_Ago'] }} week{{ dynamicShortCodes['Week_Ago'] > 1 ? 's' : '' }} ago</td>
            </tr>
            <tr>
              <td>
                <code (click)="clipboard.copy(getDynamicCode('Month_Ago'))" role="button">{{ getDynamicCode('Month_Ago') }}</code>
              </td>
              <td>
                <input [(ngModel)]="dynamicShortCodes['Month_Ago']" placeholder="Months" type="number" min="1" step="1"/>
              </td>
              <td>{{ dynamicShortCodes['Month_Ago'] }} month{{ dynamicShortCodes['Month_Ago'] > 1 ? 's' : '' }} ago</td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  </div>

  <div class="modal-footer bg-tertiary">
    <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Close</button>
  </div>
</div>
